"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var v1 = require("./v1/Colors");

var v2 = require("./v2/Colors");

var SystemColors = {
  v1: v1,
  v2: v2
};
exports.default = SystemColors;